import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { AudienceSection } from '../components/AudienceSection';
import { StepsSection } from '../components/StepsSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="w-full" data-id="element-236">
      <HeroSection data-id="element-237" />
      <StorySection data-id="element-238" />
      <ProblemSection data-id="element-239" />
      <MechanismSection data-id="element-240" />
      <BenefitsSection data-id="element-241" />
      <AudienceSection data-id="element-242" />
      <StepsSection data-id="element-243" />
      <ProofSection data-id="element-244" />
      <FAQSection data-id="element-245" />
      <OfferSection data-id="element-246" />
      <Footer data-id="element-247" />
    </main>;
}